var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"width":"100%","color":_vm.value?'red lighten-1':''},on:{"mouseleave":function($event){_vm.value = false},"click":function($event){_vm.value?
    _vm.$emit('clickDelete')
    :
    _vm.value = true}}},[(!_vm.value)?[_vm._t("default")]:[_c('v-icon',[_vm._v("delete")]),_c('div',{staticClass:"user-select-none"},[_vm._v(_vm._s(_vm.confirm_text?_vm.confirm_text:_vm.$t('Buttons.Delete')))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }